/**
 * Task #13: route a lesson onDone payload back to the right Mode.
 *
 * - `exited: true` → chapter-page (so the kid can pick another KP without
 *   re-walking academy → chapter-list). Falls back to 'home' when chapter
 *   context is missing (defensive; the chapter-page UI is the only entry
 *   point to a lesson today).
 * - Otherwise (natural completion): caller handles celebration → home.
 *
 * Returns the next mode the caller should setMode() to.
 * Caller is responsible for showing the unlock celebration on completion;
 * this function only decides where to navigate after.
 */
export type LessonDoneRoute =
  | { kind: 'home' }
  | { kind: 'chapter-page' }
  | { kind: 'celebrate-then-home'; newUnlocks: string[] };

export function lessonDoneRoute(
  result: { newUnlocks: string[]; exited?: boolean },
  ctx: { hasChapter: boolean },
): LessonDoneRoute {
  if (result.exited) {
    return { kind: ctx.hasChapter ? 'chapter-page' : 'home' };
  }
  if (result.newUnlocks.length > 0) {
    return { kind: 'celebrate-then-home', newUnlocks: result.newUnlocks };
  }
  return { kind: 'home' };
}
